import { CATALOG_SERVICE_ENDPOINTS } from "../constants/billingEndpoints";
import { buildPaginationRequest, getTotalPages } from "../utils/pagination";
import { extractCollection } from "../utils/response";

export const createCatalogServicesService = (apiClient) => ({
  async list({ page = 1, pageSize = 100, orderBy = "ASC" } = {}) {
    const response = await apiClient.post(
      CATALOG_SERVICE_ENDPOINTS.list,
      buildPaginationRequest({ page, pageSize, orderBy })
    );

    const payload = response.data || {};
    const items = extractCollection(payload, ["services"]);

    return {
      items,
      totalPages: getTotalPages(payload, items.length, pageSize),
      raw: payload,
    };
  },
});
